
import { CSSProperties } from "@mui/material/styles/createTypography"
import { IdentityClient } from "api-clients/IdentityClient"
import { PlansClient } from "api-clients/PlansClient"
import { ProductInfoService } from "services/ProductInfoService"
import Container from "components/layout/Container"
import Grid from 'components/layout/grid/Grid'
import Item from 'components/layout/grid/Item'
// import './home.scss';
import Title from "components/labels/Title"
import Subtitle from "components/labels/SubHeading"
import Page from "components/layout/Page"
import Section from "components/layout/Section"
import Button from "components/buttons/Button"
import Box from "components/layout/box/Box"
import Heading from "components/labels/Heading"
import Text from 'components/labels/Text';

import CardFeature from 'views/home/CardFeature'
import { ColorsUtil, MyTheme } from "MyTheme"
import Menu from "components/menu/Menu";
import MenuItem from "components/menu/MenuItem";
import { Avatar, Card, CardActions, CardContent, CardHeader, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Paper, Stack, Step, StepButton, StepLabel, Stepper, Table, TableBody, TableCell, TableHead, TableRow, Toolbar, useMediaQuery, Zoom } from "@mui/material"
import React, { useEffect, useRef, useState, VideoHTMLAttributes } from "react"
import useVisibility from "hooks/UseVisibility"
import Animation from "components/animations/Animation"
import SubHeading from "components/labels/SubHeading"
import TitleBlock from "components/layout/TitleBlock"
import Icon from "components/icons/Icon"
import { VideoMarker, VideoMarkersController } from "utils/VideoUtil"
import Modal from "components/modals/Dialog"
import Dialog from "components/modals/Dialog"
import { Plan } from "models/Plan"
import { Price } from "models/Price"
import FieldCollection from "components/fields/fieldCollection/FieldCollection"
import TextField from "components/fields/textField/TextField"
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { UserService } from "services/UserService"
import Form from "components/forms/Form"
import TabControl, { TabPanel } from "components/tabs/TabControl"
import Tab from "components/tabs/Tab"
import Tabs from "components/tabs/Tabs"
import ExpansionPanel from "components/transitions/expansionPanel/ExpansionPanel"
import { TenantService } from "services/TenantService"
import { Tenant } from "models/Tenant"
import { BadRequestError } from "errors/ApplicationErrors"
import { Bootstrapper } from "Bootstrapper"
import { Context } from "./Context"
import LoadingButton from "components/buttons/LoadingButton"
import { DialogUtil } from "utils/DialogUtil"


const Organizations = (props: any) => {
    const navigate = useNavigate();
    const prodInfoService = Bootstrapper.getInstance<ProductInfoService>(ProductInfoService);

    const userService = new UserService();
    const tenantService = new TenantService();
    const context = Bootstrapper.getInstance<Context>(Context);
    const theme = MyTheme();
    const bg1 = theme.palette.grey[200];
    const bg2 = theme.palette.grey['100'];
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const dialogUtils = new DialogUtil();

    const [orgPermissionMap, setOrgPermissionMap] = useState<Map<Tenant, boolean>>(new Map<Tenant, boolean>());
    const [isAnimationChaining, setIsAnimationChaining] = useState<boolean | null>(null);
    const [validationMsg, setValidationMsg] = useState<string>("");
    const [canSubmit, setCanSubmit] = useState<boolean>(true);
    const [accessKey, setAccessKey] = useState<string>("");
    const [organizations, setOrganizations] = useState<Tenant[]>([]);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const userId = userService.getActiveUserId()
    const location = useLocation();
    const handleAnimationChain = () => {
        setIsAnimationChaining(true);
    }

    useEffect(() => {
        loadDataAsync();
    }, []);

    const loadDataAsync = async() => {
        context.setBusyIndicator(true);
        var orgPermissionMap = await tenantService.getOrganizationPermissionMap(userId, userService);
        setOrgPermissionMap(orgPermissionMap);
        var orgs = Array.from(orgPermissionMap.keys());
        setOrganizations(orgs);
        context.setBusyIndicator(false);
    }

    const handleRegKeySubmit = async() => {
        if(canSubmit){
            setCanSubmit(false);
            setValidationMsg("");
            var result = await tenantService.requestAccessToOrganizationAsync(accessKey).catch((err: Error) => {
                if(err instanceof BadRequestError){
                    setValidationMsg(err?.message ?? "Invalid access key");
                    return;    
                }
                setIsOpen(false);
                throw err;

            });
            
            if(result){
                var orgs = await tenantService.getOrganizationsByUserAsync(userId);
                setOrganizations(orgs);
                onCloseModal();
            }
            else
            setCanSubmit(true);


        }

    }

    const onCloseModal = () => {
        setIsOpen(false);
        setCanSubmit(true);
        setValidationMsg(null);
        setAccessKey("");
    }


    const InviteMenu = (props: any) => {
        const {organization, ...rest} = props;
        const org = organization as Tenant;
        const [anchorEl, setAnchorEl] = React.useState(null);
        const open = Boolean(anchorEl);
        
        
        const menuClicked = (event: any) => {
            setAnchorEl(event.currentTarget);
            event.stopPropagation()
        };
    
        
        const handleClose = (e: any) => {
            setAnchorEl(null);
            e.stopPropagation();
        };

        const onViewMenuItemClick = (org: Tenant) => {
            navigate(`/organization/${org.id}`);
        }

        const onRemoveMenuItemClick = async(org: Tenant) => {
            dialogUtils.confirmDialog(
                'Are you sure you want to cancel your access to this organization?',
                async(confirm) => {
                    if(!confirm)
                        return;
                    
                    var result = await tenantService.cancelTenantMembership(org.id);
                    if(result){
                        context.setBusyIndicator(true);
                        var orgs = await tenantService.getOrganizationsByUserAsync(userId);
                        setOrganizations(orgs);
                        context.setBusyIndicator(false);
                    }
            
                }
            )
        }


        return(
            <>
            <IconButton onClick={(e: any) => menuClicked(e)}>
                <Icon normal>more_vert</Icon>
            </IconButton>
            
                <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={open}
                onClick={(e: any) => handleClose(e)}
                >
                    {orgPermissionMap.get(org) && <MenuItem onClick={(e: any) => onViewMenuItemClick(org)}>
                        View
                    </MenuItem>}
    
                    <MenuItem onClick={() => onRemoveMenuItemClick(org)}>
                        Remove
                    </MenuItem>

                </Menu>
            </>
        )
    
    }



    const getOrgsList = (orgs: Tenant[]) => {
        
        return(
                <Table className={isMobile ? "responsive-table" : "null"} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Organization</TableCell>
                            <TableCell align="right">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {orgs.map(org => {
                            return (
                                <TableRow 
                                    // component={Link} to={`/organization/${org.id}`}
                                    key={org.id}
                                >
                                    <TableCell data-label="Organization" component="th" scope="row">{org.name}</TableCell>
                                    <TableCell data-label="Action" align={isMobile ? 'left' : "right"}>
                                        <InviteMenu organization={org} />
                                    </TableCell>
                                </TableRow>
                            )
                        })}

                    </TableBody>
                </Table>
        )
    }

    const canAddOrg = userService.isAdmin() || organizations.length == 0;

    return(
        <Box flexGrow={1}>

        <Section disablePadding id="section-plans" bgColor={bg1}>
                <Animation duration="medium" overrideAnimation={isAnimationChaining} onEntering={handleAnimationChain} type='fade' direction='left' transitionDelay={0}>
                    <div>
                        <Stack spacing={1}>
                            <div>
                                <Button disabled={!canAddOrg} onClick={() => setIsOpen(true)}>Request Access</Button>
                            </div>

                            <Paper>
                                {getOrgsList(organizations)}

                            </Paper>
                        </Stack>
                    </div>
                </Animation>


                {isOpen && <Dialog 
                    action={<LoadingButton loading={!canSubmit} disabled={!canSubmit} onClick={() => handleRegKeySubmit()}>Submit</LoadingButton>}
                    title="Request Access" 
                    maxWidth="xs" 
                    open={isOpen} 
                    onClose={() => onCloseModal()}>
                            <Form 
                                flat 
                                validationMsg={validationMsg}
                                >
                                <FieldCollection>
                                    <TextField placeholder="00000000-0000-0000-0000-000000000000" value={accessKey} onChange={(ele: any) => setAccessKey(ele.target.value)} label="Access Key" {...props} />
                                </FieldCollection>
                            </Form>                    
                            </Dialog>}

        </Section>
        </Box>

    )


}


export default Organizations